export class Meta {
   
    UnidadeId: number;
    Ano: number; 
    JaneiroMeta: number;
    FevereiroMeta:number;
    MarcoMeta:number;
    AbrilMeta:number;
    MaioMeta:number;
    JunhoMeta:number;
    JulhoMeta:number;
    AgostoMeta:number;
    SetembroMeta:number;
    OutubroMeta:number;
    NovembroMeta:number;
    DezembroMeta:number;

    constructor () {
        this.UnidadeId = 0;
        this.Ano = 0;
     }  
}
